export const DOP_LANGUAGES = [
    {
        key: 'bs',
        label: 'Bosanski',
        flag: '🇧🇦'
    },
    {
        key: 'en',
        label: 'Engleski',
        flag: '🇺🇸'
    },
    {
        key: 'de',
        label: 'Njemacki',
        flag: '🇩🇪'
    },
    {
        key: 'si',
        label: 'Slovenski',
        flag: '🇸🇮'
    }
]